export default function trimStringUtil (str) {
  return str.replace(/^\s+|\s+$/g, '')
}
